import AgTable from '@containers/AgTable';
import { useAgTable } from '@hooks';
import { ColDef } from 'ag-grid-community';
import { memo, useCallback, useMemo } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import trans from 'translation';
import { KButton, KGrid } from 'uikit';

interface IProps {
  name: string;
  colDefs: ColDef<any>[];
  // pinnedBottomRowData?: any[];
  renderPinnedBottomRowDataFunc?: (_data: any) => any[];
  onSubmit: SubmitHandler<any>;
  data: any;
  isGenerating?: boolean;
  isExporting?: boolean;
  height?: number;
}

const Item = ({
  name,
  colDefs,
  renderPinnedBottomRowDataFunc,
  onSubmit,
  data,
  isExporting = false,
  isGenerating = false,
  height = 550
}: IProps) => {
  const methods = useFormContext();

  const table = useAgTable({
    name,
    colDefs,
    data: data?.items ?? [],
    onAddParams: {
      hidden: true
    }
  });

  const _onExport = useCallback(
    async (e: any) => {
      methods.setValue('isExport', true);
      await methods.handleSubmit(onSubmit)(e);
      methods.setValue('isExport', false);
    },
    [methods, onSubmit]
  );

  const _pinnedBottomRowData = useMemo(() => {
    return renderPinnedBottomRowDataFunc
      ? renderPinnedBottomRowDataFunc(data)
      : [
          {
            jobNumber: trans('total_jobs'),
            containerNumber: data?.totalJob ?? 0
          },
          {
            jobNumber: trans('total_containers'),
            containerNumber: data?.totalContainer ?? 0
          }
        ];
  }, [data, renderPinnedBottomRowDataFunc]);

  return (
    <KGrid.Container>
      <KGrid.Item xs={12}>
        <KButton.Solid
          title={trans('generate')}
          type="submit"
          isLoading={isGenerating}
          disabled={isExporting}
          // onPress={_onGenerate}
        />
      </KGrid.Item>

      <KGrid.Item xs={12}>
        <AgTable
          {...table}
          isLoading={isGenerating}
          showSearch
          pinnedBottomRowData={_pinnedBottomRowData}
          height={height}
        />
      </KGrid.Item>

      <KGrid.Item xs={12} style={{ textAlign: 'right' }}>
        <KButton.Solid
          title={trans('export_excel')}
          onPress={_onExport}
          isLoading={isExporting}
          disabled={isGenerating}
        />
      </KGrid.Item>
    </KGrid.Container>
  );
};

export default memo(Item);
